import { Box, Flex, Grid, Heading, Skeleton, Text } from '@chakra-ui/react';
import { useLocation } from 'wouter';
import { useAllCollections } from '@/lib/collectionService';
import { RecipeCollection } from '@/types/api';
import { ROUTES } from '@/types';
import { useImportSheet } from '@/contexts/ImportSheetContext';
import { CollectionTile, AddCollectionTile } from '@/components/CollectionTile';

export default function HomeCollectionsGrid() {
  const [, navigate] = useLocation();
  const { open: openImportSheet } = useImportSheet();

  const { collections: topCollections, isLoading } = useAllCollections({ limit: 4 });

  return (
    <Box>
      <Flex justify="space-between" align="baseline" px={4} pb={3}>
        <Heading
          fontFamily="heading"
          fontWeight="800"
          fontSize="15px"
          color="text.primary"
          letterSpacing="-0.2px"
        >
          Your Collections{' '}
          <Text as="span" color="accent.secondary">
            ·
          </Text>
        </Heading>
        <Text
          fontFamily="body"
          fontWeight="600"
          fontSize="12px"
          color="accent.secondary"
          cursor="pointer"
          onClick={() => navigate(ROUTES.RECIPE_GROUPS_BASE())}
        >
          See all
        </Text>
      </Flex>

      <Grid
        templateColumns={{ base: 'repeat(3, 1fr)', lg: 'repeat(5, 1fr)' }}
        gap={2}
        px={4}
        pb={4}
      >
        {isLoading ? (
          Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} borderRadius="12px" h="90px" />)
        ) : (
          <>
            {topCollections.map((collection: RecipeCollection) => (
              <CollectionTile
                key={collection.id}
                collection={collection}
                onClick={() => navigate(ROUTES.RECIPE_GROUP(collection.id))}
              />
            ))}
            <AddCollectionTile onClick={() => openImportSheet('collection')} />
          </>
        )}
      </Grid>
    </Box>
  );
}
